import { call, put, takeLatest } from "redux-saga/effects";
import {
  onSendMail,
  onSendMailSuccess,
  onSendMailError,
} from "../Store/Slices/mailSlice";
import { callSendMailApi } from "../Context/businessApi";

function* sendMailSaga({ payload }) {
  try {
    const response = yield call(callSendMailApi, payload ?? {});
    const code = response?.httpStatusCode ?? response?.status ?? response?.statusCode;
    if (code === "200" || code === 200 || code === 201 || code === "201") {
      yield put(
        onSendMailSuccess({
          message: response?.message ?? "Mail sent successfully",
          status_code: code,
        })
      );
    } else {
      yield put(
        onSendMailError({
          message: response?.message ?? "Failed to send mail",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error?.response?.data?.message ??
      error?.message ??
      "Failed to send mail";
    yield put(onSendMailError({ message, status_code: 400 }));
  }
}

export default function* mailSaga() {
  yield takeLatest(onSendMail.type, sendMailSaga);
}
